const DEFAULT_BRAND_COLOR = 'DB1931';
const HEX_COLOR_REGEX = /^#?([0-9a-f]{6})$/i;

const WHITE_RGB = [255, 255, 255];
const DARK_RGB = [17, 18, 23]; // #111217, the app's background

function normalizeHex(hex) {
  const match = typeof hex === 'string' && hex.match(HEX_COLOR_REGEX);
  return match ? match[1] : DEFAULT_BRAND_COLOR;
}

function hexToRgb(hex) {
  const normalized = normalizeHex(hex);
  return [0, 2, 4].map((offset) =>
    parseInt(normalized.slice(offset, offset + 2), 16),
  );
}

function relativeLuminance([r, g, b]) {
  const [rs, gs, bs] = [r, g, b].map((channel) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

function contrastRatio(rgbA, rgbB) {
  const luminanceA = relativeLuminance(rgbA);
  const luminanceB = relativeLuminance(rgbB);
  const lighter = Math.max(luminanceA, luminanceB);
  const darker = Math.min(luminanceA, luminanceB);
  return (lighter + 0.05) / (darker + 0.05);
}

// '#DB1931' -> '219 25 49', ready for Tailwind's rgb(var(--x) / <alpha-value>).
export function hexToChannels(hex) {
  return hexToRgb(hex).join(' ');
}

// Darkens a hex color by a fraction (0-1), for hover states.
export function darken(hex, amount = 0.15) {
  const rgb = hexToRgb(hex).map((channel) =>
    Math.max(0, Math.round(channel * (1 - amount))),
  );
  return `#${rgb.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
}

// Channels of whichever of white/dark text has better WCAG contrast on hex.
export function onColorChannels(hex) {
  const rgb = hexToRgb(hex);
  const contrastWithWhite = contrastRatio(rgb, WHITE_RGB);
  const contrastWithDark = contrastRatio(rgb, DARK_RGB);
  return contrastWithWhite >= contrastWithDark
    ? WHITE_RGB.join(' ')
    : DARK_RGB.join(' ');
}
